import { render, staticRenderFns } from "./ClipSettingV3.vue?vue&type=template&id=057f046c"
import script from "./ClipSettingV3.vue?vue&type=script&lang=js"
export * from "./ClipSettingV3.vue?vue&type=script&lang=js"
import style0 from "./ClipSettingV3.vue?vue&type=style&index=0&id=057f046c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports